import type { QuirkEntry } from "@/lib/wallet/solana/types";

/** Brave's built-in Wallet Standard provider. No unverified v1 or silent prompts. */
export const brave: QuirkEntry = {
  id: "brave",
  label: "Brave Wallet",
  names: ["Brave Wallet"],
  v1: false,
  send: "sign",
  reattach: "accounts-only",
  signIn: "none",
  signInInput: [],
  evm: {
    rdns: ["com.brave.wallet"],
    flags: ["isBraveWallet"],
    sharesPermission: "unknown",
    revokeIsSiteWide: true,
  },
  install: "https://brave.com/wallet/",
};
